const VisitorsListPage = () => {
  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-header">
          <h4 className="card-title mb-0">Visitors</h4>
        </div>
        <div className="card-body text-center text-muted py-5">
          <p className="mb-0">Visitor management will be implemented here.</p>
        </div>
      </div>
    </div>
  );
};

export default VisitorsListPage;
